import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  TemplateRef
} from '@angular/core';

import { AppService } from '@services/app.service';
import { online } from '@/Interface/status';
import { Subject } from 'rxjs';
import { PlantsNew } from '@/Interface/Register';
import { Pdetails, PlantStatusDDL } from '@/Interface/plants';
import { UtilityService } from '@services/utility.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { debounceTime, finalize } from 'rxjs/operators';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { StationsDropDown, StationYield } from '@/Interface/analysisEmi';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker/bs-daterangepicker.config';
import moment from 'moment';
import { NocUserModel } from '@/model/nocUser';
import { PermissionsService } from '@services/permissions.service';
import { DEFAULT_PERMISSIONS } from '@/constants/constants';

interface AuditTrailItem {
  id: number;
  event_type: string;
  model_name: string;
  user_type: string;
  changed_by: string;
  action: string;
  old_data: any;
  new_data: any;
  message: string;
  created_at: string;
}

@Component({
  selector: 'app-logs-user-management',
  templateUrl: './logs-user-management.component.html',
  styleUrls: ['./logs-user-management.component.scss']
})
export class LogsUserManagementComponent implements OnInit {
  @ViewChild('detailsModal') detailsModal: TemplateRef<any>;

  stationList: StationYield[] = []
  sortColumn: string = 'plantName';
  sortOrder: 'asc' | 'desc' = null;
  sortOrderPlantName: 'asc' | 'desc' | null = null;
  sortOrderCapacity: 'asc' | 'desc' | null = null;
  detail: PlantsNew[] = [];
  plantStatuslst: PlantStatusDDL[] = [];
  plantTypelst: PlantStatusDDL[] = [];
  searchElement = '';
  serialNumberArray: Array<number> = [];

  next_page: number;
  current_page: number;
  filtered_page: number;
  previous_page: number;
  last_page: number;
  total_pages: number;
  total_items: number;
  pageSize: number
  pageToGo: number = 1;
  public pageSizeControl = new FormControl(10);
  searchSubject: Subject<string> = new Subject();
  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ];
  pdetail: Pdetails;
  myData: [] = [];

  NormalizedPwowerGraph: any[] = [];
  AvailabilityPoweGraph: any[] = [];
  stationCdeList: any[] = [];
  plantNamesList: any[] = [];
  selectedPlantName: string
  normalizegraphList: any[] = [];
  NormalizedPower: any[] = [];
  AvailabilityPower: any[] = [];
  plantName: any;
  plantstatusfilter: number = 0;
  plantTypefilter: number = 0;
  state: online;
  dash: Pdetails;
  p: number = 1;
  tableLoader: boolean;
  message: boolean;
  private latestQueryParams: any = {};
  @Output() onSelected = new EventEmitter<any>();
  hasInitialized: boolean = false;

  // Modal related
  selectedItem: AuditTrailItem | null = null;
  modalReference: NgbModalRef;

  // New properties
  usersList = new NocUserModel();
  selectedRange: any;
  datePickerConfig: Partial<BsDaterangepickerConfig> = {
    showWeekNumbers: false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'datepick-today-date',
    showClearButton: true,
    clearPosition: 'right',
    adaptivePosition: true,
  };
  loader: boolean = false;
  dataLoaded: boolean = false;
  auditTrailList: AuditTrailItem[] = [];
  eventTypeList = [
    { id: 'user', name: 'User Management' },
    { id: 'role', name: 'Role Management' },
  ];
  actionTypeList = [
    { id: 'create', name: 'Create' },
    { id: 'update', name: 'Update' },
    { id: 'delete', name: 'Delete' },
  ];
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;
  constructor(
    private appservice: AppService,
    private _utilityService: UtilityService,
    private _datePipe: DatePipe,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private permService: PermissionsService,
  ) { }

  ngOnInit(): void {
    this.initComponent()
    // this.fillDropDown();
    // this.getTableData();

    // this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
    //   this.searchElement = searchTerm;
    //   this.updateQueryParams({ search: this.searchElement });
    // });

    // this.hasInitialized = false;
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();

    this.fillDropDown();

    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.updateQueryParams({ search: this.searchElement });
    });

    this.hasInitialized = false;
    if (this.permissions.canView) {
      this.getTableData();
    }
    setTimeout(() => {
      this.loader = false;
    }, 250);
  }

  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }

  // Modal Methods
  openDetailsModal(content: TemplateRef<any>, item: AuditTrailItem): void {
    this.selectedItem = item;
    this.modalReference = this.modalService.open(content, {
      size: 'xl',
      centered: true,
      backdrop: 'static'
    });
  }

  getAllFields(item: AuditTrailItem | null): string[] {
    if (!item) return [];

    const oldFields = item.old_data ? Object.keys(item.old_data) : [];
    const newFields = item.new_data ? Object.keys(item.new_data) : [];

    // Combine and deduplicate fields
    const allFields = [...new Set([...oldFields, ...newFields])];
    return allFields.sort();
  }

  onSort(event: any): void {
    const sortBy = event.sorts[0];
    this.detail.sort((a, b) => {
      const valueA = a.hasOwnProperty(sortBy.prop) ? a[sortBy.prop] : null;
      const valueB = b.hasOwnProperty(sortBy.prop) ? b[sortBy.prop] : null;

      if (typeof valueA === 'number' && typeof valueB === 'number') {
        return sortBy.dir === 'asc' ? valueA - valueB : valueB - valueA;
      } else if (typeof valueA === 'string' && typeof valueB === 'string') {
        return sortBy.dir === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      } else {
        return String(valueA).localeCompare(String(valueB));
      }
    });
  }

  private updateQueryParams(paramsToUpdate: any): void {
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };

    if (this.latestQueryParams.page && (this.latestQueryParams.status && this.latestQueryParams.type && this.latestQueryParams.changed_by && this.latestQueryParams.event_type && this.latestQueryParams.action_type && this.latestQueryParams.station_codes && this.latestQueryParams.fromDate && this.latestQueryParams.toDate)) {
      this.latestQueryParams.page = paramsToUpdate.page
    }

    if (this.latestQueryParams.search === '') {
      this.latestQueryParams.search = null;
    }

    if (this.latestQueryParams.page === 1) {
      this.latestQueryParams.page = null;
    }

    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }

    if (this.latestQueryParams.sort === null || this.latestQueryParams.column === null) {
      delete this.latestQueryParams.sort;
      delete this.latestQueryParams.column;
    }
    if (this.latestQueryParams.type === null) {
      delete this.latestQueryParams.type;
    }

    if (this.latestQueryParams.status === null) {
      delete this.latestQueryParams.status;
    }
    if (this.latestQueryParams.changed_by === null) {
      delete this.latestQueryParams.changed_by;
    }
    if (this.latestQueryParams.event_type === null) {
      delete this.latestQueryParams.event_type;
    }
    if (this.latestQueryParams.action_type === null) {
      delete this.latestQueryParams.action_type;
    }
    if (!this.latestQueryParams.fromDate && !this.latestQueryParams.toDate) {
      delete this.latestQueryParams.fromDate;
      delete this.latestQueryParams.toDate;
    }
    if (
      !this.latestQueryParams.station_codes ||
      this.latestQueryParams.station_codes.trim() === ''
    ) {
      delete this.latestQueryParams.station_codes;
    }
    if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
      this.latestQueryParams.size = paramsToUpdate.size || null;
      this.latestQueryParams.search = paramsToUpdate.search || null;
    }

    if (paramsToUpdate.search !== undefined ||
      paramsToUpdate.status !== undefined ||
      paramsToUpdate.type !== undefined ||
      paramsToUpdate.changed_by !== undefined ||
      paramsToUpdate.event_type !== undefined ||
      paramsToUpdate.action_type !== undefined ||
      paramsToUpdate.station_codes !== undefined ||
      paramsToUpdate.fromDate !== undefined ||
      paramsToUpdate.toDate !== undefined) {

      this.latestQueryParams.page = 1;
    }

    this.getTableData();
  }

  private getTableData(): void {
    const name = this.latestQueryParams['search'] || this.searchElement;

    const page = this.latestQueryParams['page']
      ? +this.latestQueryParams['page']
      : 1;

    const size = this.latestQueryParams['size']
      ? +this.latestQueryParams['size']
      : 10;

    const sort = this.latestQueryParams['sort'] || null;
    const column = this.latestQueryParams['column'] || null;

    const changed_by = this.latestQueryParams['changed_by'] || null;
    const event_type = this.latestQueryParams['event_type'] || null;
    const action_type = this.latestQueryParams['action_type'] || null;

    const fromDate = this.latestQueryParams['fromDate'] || null;
    const toDate = this.latestQueryParams['toDate'] || null;

    this.getAuditTrail(
      name,
      page,
      size,
      sort,
      column,
      changed_by,
      event_type,
      action_type,
      fromDate,
      toDate
    );
  }

  getAuditTrail(
    name: string,
    page: number,
    size: number,
    sort: string | null,
    column: string | null,
    changed_by: string | null,
    event_type: string | null,
    action_type: number | null,
    fromDate?: string | null,
    toDate?: string | null
  ): void {
    this.tableLoader = true;
    this.serialNumberArray = [];

    this._utilityService
      .getAuditTrail(
        name,
        page,
        size,
        sort,
        column,
        changed_by,
        event_type,
        action_type,
        fromDate,
        toDate
      )
      .pipe(
        finalize(() => {
          this.tableLoader = false;
          this.dataLoaded = true;
        })
      )
      .subscribe({
        next: (res: any) => {
          if (res?.status === 200) {
            this.auditTrailList = res.data || [];

            this.current_page = res.current_page;
            this.next_page = res.next_page;
            this.previous_page = res.previous_page;
            this.total_pages = res.total_pages;
            this.total_items = res.total_activities;

            this.enablePagination();
          } else {
            this.auditTrailList = [];
          }
        },
        error: err => {
          this.auditTrailList = [];
          console.error('Failed to load audit trail data:', err);
        }
      });
  }

  getActionClass(action: string): string {
    switch (action?.toLowerCase()) {
      case 'create':
        return 'tag-create';
      case 'update':
        return 'tag-update';
      case 'delete':
        return 'tag-delete';
      default:
        return 'tag-default';
    }
  }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    date.setHours(date.getHours() + 5);

    return this._datePipe.transform(
      date,
      'dd MMM, yyyy | hh:mm a'
    ) || dateString;
  }
  // formatDate(dateString: string): string {
  //   const date = new Date(dateString);
  //   return this._datePipe.transform(dateString,'dd MMM, yyyy | hh:mm a','+0500');
  //   // return this._datePipe.transform(date, 'dd MMM, yyyy | hh:mm a') || dateString;
  // }

  sortPlants(column: string): void {
    if (this.sortColumn === column) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortOrder = 'asc';
    }

    let sortValue: string | null = null;
    let columnName: string;

    if (this.sortOrder === 'asc') {
      sortValue = '0';
    } else if (this.sortOrder === 'desc') {
      sortValue = '1';
    }

    if (column === 'plantName') {
      columnName = 'stationName';
      this.sortOrderPlantName = this.sortOrder;
      this.sortOrderCapacity = null;
    } else if (column === 'capacity') {
      columnName = column;
      this.sortOrderCapacity = this.sortOrder;
      this.sortOrderPlantName = null;
    }

    this.updateQueryParams({ sort: sortValue, column: columnName });
  }

  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    this.searchSubject.next(this.searchElement);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page: page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize })
  }

  fillDropDown() {
    this.plantStatuslst = [];
    this.plantStatuslst.push(new PlantStatusDDL(1, 'Offline'));
    this.plantStatuslst.push(new PlantStatusDDL(2, 'Faulty'));
    this.plantStatuslst.push(new PlantStatusDDL(3, 'Online'));

    this.plantTypelst.push(new PlantStatusDDL(1, 'Huawei'));
    this.plantTypelst.push(new PlantStatusDDL(2, 'GoodWe'));
    this.plantTypelst.push(new PlantStatusDDL(3, 'Deye'));

    this.dropDownInit()
  }

  Filterplants(filter: string) {
    this.tableLoader = true;

    this.appservice.FilteredPlantsdetails(filter).subscribe((res) => {
      if (res) {
        this.detail = res.data.map((plant: any) => {
          plant.capacity = plant.capacity.toFixed(2);
          plant.specificYield = (plant.specificYield * 1000).toFixed(2);
          plant.currentPower = plant.currentPower.toFixed(2);
          plant.energyToday = plant.energyToday.toFixed(2);
          return plant;
        });
        this.stationCdeList = res.stationCodes;
        this.current_page = res.current_page;
        if (res.next_page == null) {
          this.next_page = res.last_page;
        }
        else {
          this.next_page = res.next_page;
        }
        this.previous_page = res.previous_page;
        this.last_page = res.last_page;
        this.total_pages = res.total_pages;
        this.enablePagination();

        this.hasInitialized = false;
        this.tableLoader = false;
      }
    });
  }

  enablePagination() {
    const linkElement = document.getElementById('prevPage');

    if (this.previous_page === null) {
      linkElement.setAttribute('disabled', 'true');
      linkElement.style.pointerEvents = 'none';
      linkElement.style.color = 'gray';
      linkElement.addEventListener('click', (event) => {
        event.preventDefault();
      });
    } else {
      linkElement.removeAttribute('disabled');
      linkElement.style.pointerEvents = 'auto';
      linkElement.style.color = '';
      linkElement.removeEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  }

  Status() {
    this.appservice.plantStatus().subscribe((res) => {
      this.state = res.data;
    });
  }

  createfilter(): string {
    var filter = "";
    if (!(this.plantName === null || this.plantName == undefined)) {
      if (this.plantName !== "") {
        filter = filter + "search=" + this.plantName;
      }
    }
    if (this.filtered_page >= 0) {
      if (filter !== "") {
        filter = filter + '&';
      }
      filter = filter + "page=" + this.filtered_page;
    }

    if (this.plantstatusfilter > 0) {
      if (filter !== "") {
        filter = filter + '&';
      }
      filter = filter + "status=" + this.plantstatusfilter;
    }

    if (this.plantTypefilter > 0) {
      if (filter !== "") {
        filter = filter + '&';
      }
      filter = filter + "type=" + this.plantTypefilter;
    }

    return filter;
  }

  public selectedChangeBy(user: any): void {
    const queryParams = {
      changed_by: user ? user.user_id : null
    };
    this.updateQueryParams(queryParams);
  }

  public selectedEventType(event: any): void {
    const queryParams = {
      event_type: event ? event.id : null
    };
    this.updateQueryParams(queryParams);
  }

  public selectedActionType(event: any): void {
    const queryParams = {
      action_type: event ? event.id : null
    };
    this.updateQueryParams(queryParams);
  }

  public selectContractType(contractType: any[] | null) {
    const id = contractType?.map(p => p.id).join(',') || '';
    this.updateQueryParams({ contract_type_id: id });
  }

  public selectRegion(region: any[] | null) {
    const id = region?.map(p => p.id).join(',') || '';
    this.updateQueryParams({ region_id: id });
  }

  public selectCity(city: any[] | null) {
    const id = city?.map(p => p.id).join(',') || '';
    this.updateQueryParams({ city_id: id });
  }

  selctPlantlistStatus(sourceId) {
    let statusQueryParam = null;
    if (sourceId === null || sourceId == undefined) {
      this.plantstatusfilter = 0;
    }
    else {
      this.plantstatusfilter = sourceId;
      statusQueryParam = sourceId;
    }
    this.updateQueryParams({ status: statusQueryParam });
  }

  selctPlantlistType(sourceId) {
    let typeQueryParam = null;
    if (sourceId === null || sourceId == undefined) {
      this.plantTypefilter = 0;
    }
    else {
      this.plantTypefilter = sourceId;
      typeQueryParam = sourceId;
    }

    this.updateQueryParams({ type: typeQueryParam });
  }

  Pagination(pageNo: number) {
    if (pageNo >= 1 && pageNo <= this.total_pages) {
      this.filtered_page = pageNo;
      this.Filterplants(this.createfilter());
    }
  }

  Search() {
    if (this.plantName == '') {
      this.ngOnInit();
    } else {
      this.Filterplants(this.createfilter());
    }
  }

  key: string = 'capacity';
  reverse: boolean = false;
  sort(key: any) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  dropDownInit() {
    this.getUser()
  }

  onRangeChange(dates: Date[]): void {
    if (dates?.length === 2) {
      const [start, end] = dates;
      const diffInMs = Math.abs(end.getTime() - start.getTime());
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24) + 1;

      if (diffInDays > 31) {
        this.toastr.warning('Please select a date range of 31 days or less.');
        this.selectedRange = null as any;

        setTimeout(() => {
          this.selectedRange = [];
        });
      }

      this.selectedRange = dates;

      const formattedFromDate = moment(start).format('YYYY-MM-DD');
      const formattedToDate = moment(end).format('YYYY-MM-DD');
      this.updateQueryParams({
        fromDate: formattedFromDate,
        toDate: formattedToDate
      });
    }
    else {
      this.updateQueryParams({
        fromDate: null,
        toDate: null
      });
    }
  }

  getUser() {
    this._utilityService.getAllUsersDropdown().subscribe((res) => {
      if (res) {
        this.usersList = res;
      }
    });
  }

  hasOldData(item: AuditTrailItem): boolean {
    return item.old_data && Object.keys(item.old_data).length > 0;
  }

  hasNewData(item: AuditTrailItem): boolean {
    return item.new_data && Object.keys(item.new_data).length > 0;
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  clearDateRange(): void {
    if (this.selectedRange) {
      this.selectedRange = null
      this.updateQueryParams({ fromDate: null, toDate: null })
    }
  }

  formatData(data: any): string {
    if (!data) return 'No data';
    return JSON.stringify(data, null, 2);
  }
}